import React from 'react';
export enum Position {
    RIGHT = 'right',
    BOTTOM = 'bottom',
    POPUP_RELATIVE = 'popup-relative',
    POPUP_CENTERED = 'popup-centered'
}
export interface ModalPanelConfiguration {
    isOpen?: boolean;
    position?: Position;
    toggle?: any;
    children?: React.ReactNode;
}

const ModalPanel = ({ isOpen, position, toggle, children }: ModalPanelConfiguration) => {
    const innerClassname = `panel ${position} ${isOpen ? 'open' : 'closed'}`;
    return (
        <div className='modal-panel'>
            {isOpen && <div onClick={toggle} className='overlay'></div>}
            <div className={innerClassname}>{children}</div>
        </div>
    );
};
export default ModalPanel;
